export const isLoggedIn = state => {
  return state.isLoggedIn
}
export const currentUserName = state => state.userName
export const userRole = state => state.permissions
export const disabledUser = state => state.disabled


// WEBPACK FOOTER //
// ./src/store/modules/login/getters.js